import { render, staticRenderFns } from "./Arrivalnotice.vue?vue&type=template&id=07409283&scoped=true&"
import script from "./Arrivalnotice.vue?vue&type=script&lang=js&"
export * from "./Arrivalnotice.vue?vue&type=script&lang=js&"
import style0 from "./Arrivalnotice.vue?vue&type=style&index=0&id=07409283&scoped=true&lang=scss&"
import style1 from "./Arrivalnotice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07409283",
  null
  
)

export default component.exports